import React, { useMemo, useContext } from 'react';
import WorkpageApi from '../api/WorkpageApi';
import LookupApi from '../api/LookupApi';
import Loader from '../components/Loader';
import useResourceLoader from '../util/useResourceLoader';
import { AuthContext } from './AuthContext';

const UWEContext = React.createContext();

UWEContext.Component = function UWEContext_Component(props) {
  const { children } = props;
  const { value, loading } = useUWEContextComponentHooks(props);

  return <UWEContext.Provider value={value}>{loading !== false ? <Loader fullscreen spinner /> : children}</UWEContext.Provider>;
};

function useUWEContextComponentHooks() {
  const auth = useContext(AuthContext);

  const [allWorkpages, loadingAllWorkpages, errorLoadingWorkpages] = useResourceLoader(() => {
    if (auth.user) {
      return WorkpageApi.list().then(data => {
        if (data?.length) {
          data[0].default = true;
        }
        return data;
      });
    }

    return Promise.resolve([]);
  }, [auth]);

  const workpages = allWorkpages?.filter(wp => !wp.isAdmin) || [];
  const adminWorkpages = allWorkpages?.filter(wp => wp.isAdmin) || [];
  const hasAdminWorkpages = adminWorkpages.length > 0;

  const [appOptions, loadingAppOptions, errorLoadingAppOptions] = useResourceLoader(async () => await LookupApi.getAppOptions(), []);

  const loading = loadingAllWorkpages || loadingAppOptions;
  const error = errorLoadingWorkpages || errorLoadingAppOptions;

  const value = useMemo(
    () => ({
      workpages,
      adminWorkpages,
      hasAdminWorkpages,
      appOptions,
    }),
    [workpages, adminWorkpages, hasAdminWorkpages, appOptions]
  );

  return {
    value,
    loading,
    error,
  };
}

export default UWEContext;
